import React from 'react';
import classNames from 'classnames';
import { useServiceStatus } from '#network/Support';
import { openExternalLink } from '#app-config';
import Button from '#components/Elements/Button/Button';
import styles from './ServiceStatusBanner.scss';

const supportedColors = {
  warning: styles.warning,
  danger: styles.danger,
};

export default function ServiceStatusBanner() {
  // const { message, url, category, action } = useServiceStatus() || {};

  // if (message) {
  //   return (
  //     <div className={classNames(styles.banner, supportedColors[category])}>
  //       <div className={styles.message}>{message}</div>
  //       {!!action && (
  //         <div className={styles.buttons}>
  //           <Button
  //             transparent
  //             color={supportedColors[category] ? category : 'primary'}
  //             className="no-drag"
  //             onClick={url ? () => openExternalLink(url) : undefined}
  //           >
  //             {action}
  //           </Button>
  //         </div>
  //       )}
  //     </div>
  //   );
  // }
  return null;
}
